import script from "./GenerateTagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateTagDialog.vue?vue&type=script&setup=true&lang=js"

import "./GenerateTagDialog.vue?vue&type=style&index=0&id=1730a034&lang=css"

const __exports__ = script;

export default __exports__